import Model from '@/store/model';

class PerfectLessons extends Model {
  map(json) {
    super.map(json);
  }
}
export default PerfectLessons;
